<!-- <div class="file-selector" (click)="triggerFileInput()">
<p *ngIf="!selectedFile">Click here to select a file</p>
<p *ngIf="selectedFile">{{ selectedFile.name }}</p>
</div>
<input
  type="file"
  id="fileInput"
  accept=".xlsx,.xls"
  (change)="onFileSelected($event)"
  style="display: none"
  /> -->


  <div class="file-selector" (click)="triggerFileInput()">
    <i class="fa-solid fa-cloud-arrow-up" style="font-size: 50px;margin-bottom: 10px; color: #626E77;"></i>
    @if (!selectedFiles?.length) {
      <span>Click here to upload records</span>
    }
    <br>
      @if (info) {
        <span>{{ info }}</span>
      }
      @if (subInfo) {
        <span>{{ subInfo }}</span>
      }

      <!-- Single file selected -->
      @if (!allowMultiple && selectedFiles?.length) {
        <p>
          {{ selectedFiles[0].name }}
          <span class="remove-icon" (click)="removeFile(0)">&#10006;</span>
        </p>
      }

      <!-- Multiple files selected -->
      @if (allowMultiple && selectedFiles?.length) {
        <div class="file-list-box">
          @for (file of selectedFiles; track file; let i = $index) {
            <p class="file-item">
              <span class="file-name">{{ file.name }}</span>
              <span class="remove-icon" (click)="removeFile(i)">&#10006;</span>
            </p>
          }
        </div>
      }
      <!-- <div *ngIf="allowMultiple && selectedFiles?.length" class="file-list-box">
      <p *ngFor="let file of selectedFiles; let i = index" class="file-item">
        {{ file.name }}
        <span class="remove-icon" (click)="removeFile(i)">&#10006;</span>
      </p>
    </div> -->
  </div>

  <input
    type="file"
    id="fileInput"
    [attr.multiple]="allowMultiple ? true : null"
    [attr.accept]="acceptedFiles"
    (change)="onFileSelected($event)"
    style="display: none"
    />